import { DeliveryInformation } from "../../settings/account/deliveries/intarfaces";
import { Product } from '../../product/product.types';
import { OrderRescheduled } from "../../settings/account/profile/profile.types";
import { Subscription } from "../../settings/account/subscriptions/subscriptions.types";
import { PublishedBundles } from "../types/order.type";
import { RetentionCoupon } from "../types/account.types";
import { PendingMembershipCharge } from "../pending-membership/pending-membership.types";

/** Steps the signup onboarding modal can render, in the order they are shown. */
export enum SignupOnboardingSteps {
  WELCOME = 'WELCOME',
  NEW_CHECKOUT_FLOW = 'NEW_CHECKOUT_FLOW',
}

export interface SignupOnboarding {
  steps: SignupOnboardingSteps[];
  /** Heading of the welcome step. The shell title stays empty so each step can title itself. */
  welcomeTitle: string;
  /** First-login copy for accounts configured with a custom welcome message. */
  customWelcomeMessage?: string;
}

export interface ModalContentData {
  title?: string;
  textContent?: string;
  isBeforeCutoffTime?: boolean;
  cancelButtonText?: string;
  confirmButtonText?: string;
  hasSession?: boolean;
  closeable?: boolean;
  closeOthers?: boolean;
  fullScreenOnMobile?: boolean;
  howItWorks?: DeliveryInformation;
  welcomeMessage?: DeliveryInformation;
  signupOnboarding?: SignupOnboarding;
  boxDetail?: BoxDetail;
  pauseSubscription?: PauseSubscription;
  becomeAMemeber?: BecomeAMemeber;
  buyAgain?: BuyAgain;
  changeCredentials?: ChangeCredentials;
  orderHistoryWarning?: {
    showThirdColumn: boolean;
    fromOrder: boolean;
    products: OrderHistoryWarning[];
  };
  deliveryDaySelection?: {
    zoneId: number
  };
  subscriptionNextDelivery?: {
    availableDates: AvailableDates[]
  };
  preOrderProduct?: Partial<Product>;
  rescheduledOrders?: OrderRescheduled[];
  resumeSubscriptions?: ResumeSubscriptions;
  authNetPurchase?: any;
  nmiPurchase?: any;
  quantity?: number;
  suggestedProducts?: any[],
  afterBundleAdded?: AfterBundleAdded
  retentionCoupons?: {
    coupons: RetentionCoupon[],
    minimumSubscriptionRequired: boolean
    subscriptionId: number
  }
  pastDue?: PastDueInfo;
  invoiceHistory?: {
    /** When true the modal asks the backend for only the past-due invoices, so
     *  the customer sees what they owe instead of the full history the settings
     *  route renders. */
    unpaidOnly?: boolean;
  };
  /** The membership a card save is about to start, and the free levels offered
   *  instead of it (DEV-11022). */
  pendingMembership?: PendingMembershipCharge;
}

export interface PastDueInfo {
  pastDueBalance: number;
  daysUntilSuspension?: number | null;
  invoiceHistoryPath: string;
}

export interface AfterBundleAdded {
  product: Product;
  isSubscription: boolean
}

export interface ResumeSubscriptions {
  subscriptions: Subscription[];
}

export interface AvailableDates {
  date: string
  originalDate: string
}

export interface BoxDetail {
  isSubscription: boolean;
  existsInOrder?: boolean;
  startDate: string;
  endDate: string;
  publishedBundles: PublishedBundles[];
  detail: BoxDetailItem[]
}

export interface BoxDetailItem {
  productName: string;
  quantity: number;
  packageName: string;
  producer: string;
  price: number;
  img: string;
}

export interface PauseDates {
  startDate: string,
  endDate: string
}

export interface PauseSubscription {
  currentWeekInfo?: string,
  current?: PauseDates,
  nextWeekInfo?: string,
  next?: PauseDates,
  minAvailableDate?: string,
  minAvailableDay?: string
}

export interface BecomeAMemeber {
  membershipCost: number;
  creditCardLastNumbers: string;
  deposit: number;
  membershipName: string;
  membershipFrequency: string;
}

export interface BuyAgain {
  orderHistoryId: number
}

export interface ChangeCredentials {
  email?: string;
}

export interface OrderHistoryWarning {
  productName: string;
  productVariant: string;
  outOfStock?: boolean
  limitExceeded?: boolean;
  reason?: string;
  previousQuantity?: number;
}
